import { startCase } from 'Utils/filters';
import template from './groupPermissions.html';
import './groupPermissions.scss';

function getDefaultPermissions() {
  return {
    dashboard: {
      cameras: {
        settingsMenu: 'enable',
        takeSnapshot: 'enable',
        openRecordings: 'enable',
        ptzOverlay: 'enable',
        resetIR: 'enable',
        toggleFullscreen: 'enable',
        streamSettings: 'enable',
        ptzSettings: 'enable',
        zoneSettings: 'enable',
        audioSettings: 'enable',
      },
      accessControls: {
        dial: 'enable',
      },
      eventDetails: {
        summary: 'destroy',
      }
    }
  };
}

function getSuperAdminDefaultPermissions() {
  return {
    dashboard: {
      cameras: {
        settingsMenu: 'enable',
        takeSnapshot: 'enable',
        openRecordings: 'enable',
        ptzOverlay: 'enable',
        resetIR: 'enable',
        toggleFullscreen: 'enable',
        streamSettings: 'enable',
        ptzSettings: 'enable',
        zoneSettings: 'enable',
        audioSettings: 'enable',
      },
      accessControls: {
        dial: 'enable',
      },
      eventDetails: {
        summary: 'destroy', // Keep Summary hidden for superAdmins initially
      }
    }
  };
}

export default {
  name: 'groupPermissions',
  template,
  controller: [
    'UserInfoService',
    GroupPermissions
  ],
  controllerAs: 'GroupPermCtrl',
  bindings: {
    permConfig: '<',
    clickAction: '&',
  },
};


function GroupPermissions(UserInfoService) {
  const vm = this;

  // //////////////// //
  // Public Variables //
  // //////////////// //
  vm.permissionsCollapsed = true;
  vm.options = {
    enable: 'Enabled',
    disable: 'Disabled',
    destroy: 'Hidden', // show the admin 'Hidden', but actually destroy the element
  };
  // Default permission levels for each user kind
  vm.defaultPermissionLevels = {
    normal: getDefaultPermissions(),
    admin: getDefaultPermissions(),
    partner: getDefaultPermissions(),
    superAdmin: getSuperAdminDefaultPermissions(),
  };
  // Track collapsed state for each user kind's permission level section
  vm.permissionLevelsCollapsed = {
    normal: true,
    admin: true,
    partner: true,
    superAdmin: true,
  };

  // //////////////// //
  // Public Functions //
  // //////////////// //
  vm.$onChanges = onChanges;
  vm.togglePermissionsCollapse = togglePermissionsCollapse;
  vm.startCase = startCase;
  vm.getEditableUserKinds = getEditableUserKinds;
  vm.togglePermissionLevelCollapse = togglePermissionLevelCollapse;
  vm.hasPermissions = userKind => !_.isEmpty(vm.permConfigCopy[userKind]);

  function onChanges(changes) {
    // Merge default permission levels for all user kinds
    vm.permConfigCopy = _.merge({}, vm.defaultPermissionLevels, changes.permConfig?.currentValue);
  }

  // Returns array of user kinds that the current user can edit permission levels for
  function getEditableUserKinds() {
    try {
      const userKind = UserInfoService.getCurrentUserKind();
      const USER_KINDS = UserInfoService.getUserKinds();

      const idx = USER_KINDS.indexOf(userKind);

      if (idx < 0) {
        return [];
      }

      // SuperAdmins can edit permission levels for all user kinds including themselves
      if (userKind === 'superAdmin') {
        return USER_KINDS; // All user kinds: ['normal', 'admin', 'partner', 'superAdmin']
      }

      // Other user kinds can only edit permission levels for kinds below their level
      if (idx <= 0) {
        return [];
      }

      // Only allow editing permission levels for user kinds below the current user's level
      return USER_KINDS.slice(0, idx);
    } catch (error) {
      console.error('Error in getEditableUserKinds:', error);
      return [];
    }
  }

  function togglePermissionsCollapse() {
    vm.permissionsCollapsed = !vm.permissionsCollapsed;
  }

  function togglePermissionLevelCollapse(userKind) {
    vm.permissionLevelsCollapsed[userKind] = !vm.permissionLevelsCollapsed[userKind];
  }
}
